import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import { generateIcon, handlize, pictureGenerate, printMoney, removeFromCart, t, updateCart } from '@process-creative/slate-theme-tools';
import { html, unsafeHTML } from './../../tools/utilities/component';
import { shopifyAjaxErrorGet } from '../../tools/utilities/error';
import { quantitySelectorCreate } from '../../objects/product/quantity-selector';
import { CartState } from './cart-drawer-component';
import { LineItem } from '../../tools/cart/line-item';
import { CartSubscriptionWidgetCreate } from './cart-subscription-widget';
export var cartLineCreate = function cartLineCreate(p) {
  var _item$properties3;

  var item = p.item,
      index = p.index,
      disabled = p.disabled,
      bundleProducts = p.bundleProducts,
      state = p.state;
  var realIndex = index + 1; // Thanks shopify.
  // Setup basic variables

  var url = item.url;
  var quantity = item.quantity;
  var bundlePrice = bundleProducts === null || bundleProducts === void 0 ? void 0 : bundleProducts.reduce(function (p, i) {
    return i.line_price + p;
  }, 0); // Event Listeners

  var eventRemoveClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var _item$properties;

      var _item$properties2, bundleId;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();

              if (!((_item$properties = item.properties) !== null && _item$properties !== void 0 && _item$properties.isProductBundle)) {
                _context.next = 6;
                break;
              }

              bundleId = (_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2.isProductBundle;
              removeBundleItems(bundleId);
              _context.next = 14;
              break;

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return removeFromCart(realIndex);

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](6);
              console.error(shopifyAjaxErrorGet(_context.t0));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 11]]);
    }));

    return function eventRemoveClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  function removeBundleItems(_x2) {
    return _removeBundleItems.apply(this, arguments);
  }

  function _removeBundleItems() {
    _removeBundleItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bundleId) {
      var items, bundleLinesSorted, _iterator, _step, line;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              items = state.cart.items;
              bundleLinesSorted = [realIndex].concat(_toConsumableArray(items.reduce(function (lines, item, index) {
                var _item$properties4;

                if (((_item$properties4 = item.properties) === null || _item$properties4 === void 0 ? void 0 : _item$properties4._isChildProduct) == bundleId) {
                  lines.push(index + 1);
                }

                return lines;
              }, []))).sort(function (a, b) {
                return b - a;
              });
              _iterator = _createForOfIteratorHelper(bundleLinesSorted);
              _context3.prev = 3;

              _iterator.s();

            case 5:
              if ((_step = _iterator.n()).done) {
                _context3.next = 17;
                break;
              }

              line = _step.value;
              _context3.prev = 7;
              _context3.next = 10;
              return removeFromCart(line);

            case 10:
              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](7);
              console.error(shopifyAjaxErrorGet(_context3.t0));

            case 15:
              _context3.next = 5;
              break;

            case 17:
              _context3.next = 22;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t1 = _context3["catch"](3);

              _iterator.e(_context3.t1);

            case 22:
              _context3.prev = 22;

              _iterator.f();

              return _context3.finish(22);

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 19, 22, 25], [7, 12]]);
    }));
    return _removeBundleItems.apply(this, arguments);
  }

  var eventQuantityChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(newQuantity) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(newQuantity === quantity)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return updateCart(realIndex, newQuantity);

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              console.error(shopifyAjaxErrorGet(_context2.t0));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 7]]);
    }));

    return function eventQuantityChange(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var subtitle = item === null || item === void 0 ? void 0 : (_item$properties3 = item.properties) === null || _item$properties3 === void 0 ? void 0 : _item$properties3._subtitle; // Generate the line item

  return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    <div class=\"c-cart-line\">\n      <div class=\"c-cart-line__row\">\n        <a href=\"", "\" class=\"c-cart-line__image-wrapper\">\n          <div class=\"c-cart-line__image-container o-responsive-image-container\">\n            ", "\n          </div>\n        </a>\n\n        <div class=\"c-cart-line__container\">\n          <div class=\"c-cart-line__heading\">\n            <div class=\"c-cart-line__content\">\n\n              ", "\n\n              ", "\n\n              ", "\n\n              ", "\n            </div>\n\n            <div class=\"c-cart-line__remove\" @click=", ">\n              <span class=\"c-cart-line__remove-text\">\n                ", "\n              </span>\n              ", "\n            </div>\n          </div>\n\n          <div class=\"c-cart-line__bottom\">\n            <div class=\"c-cart-line__details\">\n\n              ", "\n\n\n              <div class=\"c-cart-line__pricing o-type--4\">\n                ", "\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"c-cart-line__subscription-container\">\n          ", "\n        </div>\n      </div>\n    </div>\n  "])), url, unsafeHTML(pictureGenerate({
    class: 'c-cart-line__image o-responsive-image',
    src: item.image || '',
    srcSize: 200,
    sizes: [{
      size: 150,
      screen: 375
    }]
  })), item.product_title == 'default title' ? '' : html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                <a href=\"", "\" class=\"c-cart-line__title o-heading is-size-4\">\n                  ", "\n                </a>\n              "])), url, item.product_title), !subtitle ? '' : html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                <div class=\"c-cart-line__subtitle \">\n                  ", "\n                </div>\n              "])), subtitle), item.options_with_values.map(function (option) {
    return option.value == 'Default Title' ? html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""]))) : html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                  <p class=\"c-cart-line__option\">\n                    ", ": ", "\n                  </p>\n                "])), option.name.toLowerCase(), option.value.toLowerCase());
  }), !bundleProducts ? '' : html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                <div class=\"c-cart-line__bundle-items\">\n                  ", "\n                </div>\n              "])), bundleProducts.map(function (item) {
    return html(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<div class=\"c-cart-line__bundle-item\">\n                      - ", "\n                    </div>"])), item.title);
  })), eventRemoveClick, t('cart.remove'), unsafeHTML(generateIcon('cross', 'c-cart-line__remove-icon')), bundleProducts ? '' : html(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["<div class=\"c-cart-line__quantity-wrapper\">\n                <div class=\"c-cart-line__quantity\">\n                  ", "\n                </div>\n              </div>"])), quantitySelectorCreate({
    quantity: quantity,
    onChange: eventQuantityChange,
    min: 1,
    disabled: disabled
  })), bundleProducts ? html(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["<shop-money money=\"", "\" moneyclass=\"is-money\">\n                    ", "\n                  </shop-money>"])), item.price, printMoney(bundlePrice)) : item.original_price ? html(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                  <shop-money money=\"", "\" moneyclass=\"is-money\"\n                    compare=\"", "\" compareclass=\"is-compare\"\n                  >\n                    ", "\n                  </shop-money>\n                "])), item.price, item.original_price, printMoney(item.price)) : html(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n                  <shop-money money=\"", "\" moneyclass=\"is-money\">\n                    ", "\n                  </shop-money>\n                "])), item.price, printMoney(item.price)), CartSubscriptionWidgetCreate({
    index: index,
    cartState: state
  }));
};